module.exports = __webpack_public_path__ + "static/media/2a.cc152957.gif";